module.exports = {
  "0": {
    "1": "圆通速递",
    "2": "中通速递",
    "3": "顺丰速运",
    "4": "韵达快递",
    "5": "申通快递",
    "6": "EMS",
    "7": "百世汇通",
    "8": "贝海国际速递",
    "9": "天天快递",
    "10": "139快递", 
    "11": "爱彼西",
    "12": "安世通国际快递",
    "13": "城市100",
    "14": "德邦",
    "15": "递易自提柜",
    "16": "EMS经济快递",
    "17": "e栈",
    "18": "凡宇速递",
    "19": "发网",
    "20": "飞鹰货运",
    "21": "丰巢快递柜",
    "22": "富友",
    "23": "国通快递",
    "24": "海红网送",
    "25": "鸿怡快递",
    "26": "汇诚通物流",
    "27": "汇文",
    "28": "佳惠尔",
    "29": "佳吉快运",
    "30": "佳怡物流",
    "31": "积客莱速递",
    "32": "金速金速递",
    "33": "酒仙网",
    "34": "快捷速递",
    "35": "联邦快递",
    "36": "联邦快递陆运",
    "37": "立即送",
    "38": "魔格",
    "39": "南宁腾达融联",
    "40": "宁夏万家通",
    "41": "全峰快递",
    "42": "全一快递",
    "43": "日日顺家居",
    "44": "日日顺乐家",
    "45": "荣庆物流",
    "46": "如风达",
    "47": "赛澳递",
    "48": "思迈速递",
    "49": "速递易",
    "50": "速尔",
    "51": "天地华宇",
    "52": "微特派（北京）",
    "53": "微特派（广州）",
    "54": "微特派（湖北）",
    "55": "微特派（上海）",
    "56": "微特派（天津）",
    "57": "为为网",
    "58": "先飞达物流",
    "59": "新邦物流",
    "60": "信丰物流",
    "61": "亚风",
    "62": "一邦",
    "63": "易泊",
    "64": "优速快递",
    "65": "远成物流",
    "66": "云柜",
    "67": "宅急送",
    "68": "芝麻开门（杭州）",
    "69": "中睿速递",
    "70": "中铁快运",
    "71": "中铁物流",
    "72": "中外运-敦豪",
    "73": "中宜快运",
} 

}


// WEBPACK FOOTER //
// ./src/config/page/cn/express/index.js